export default {
  codename: "",
  description: "",
  categoryIds: null,
};
